// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26sqj","col":"styles_col__UqTR0"};